"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

const INTEGRATIONS = [
  {
    name: "Instagram",
    desc: "Official Instagram Graph API integration with OAuth 2.0 authentication.",
    status: "Live",
    icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z",
  },
  {
    name: "Meta Business",
    desc: "Seamlessly connect with Meta Business Suite for enhanced account management.",
    status: "Coming Soon",
    icon: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
  {
    name: "Slack",
    desc: "Get real-time notifications for new leads and conversations in your Slack workspace.",
    status: "Coming Soon",
    icon: "M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z",
  },
  {
    name: "Zapier",
    desc: "Connect with 5,000+ apps through Zapier automation workflows.",
    status: "Coming Soon",
    icon: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 18.75a6.75 6.75 0 1 1 6.75-6.75 6.758 6.758 0 0 1-6.75 6.75zm0-11.25a4.5 4.5 0 1 0 4.5 4.5 4.507 4.507 0 0 0-4.5-4.5z",
  },
  {
    name: "Google Sheets",
    desc: "Export leads and analytics directly to your Google Sheets.",
    status: "Coming Soon",
    icon: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm4 8h-2v-6h2v6zm0-8h-2V5h2v6zm4 8h-2v-6h2v6zm0-8h-2V5h2v6z",
  },
  {
    name: "Webhooks",
    desc: "Send data to any custom endpoint with our webhook integration.",
    status: "Coming Soon",
    icon: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1",
  },
];

export default function IntegrationsPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl mx-auto"
        >
          <div className="mb-16">
            <p
              className="text-xs tracking-[0.3em] uppercase mb-3"
              style={{ color: "rgba(201,168,76,0.7)", fontFamily: "'Montserrat', sans-serif" }}
            >
              Integrations
            </p>
            <h1
              className="text-4xl md:text-5xl font-light leading-tight mb-4"
              style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
            >
              Connect your Instagram automation{" "}
              <span style={{ color: "#C9A84C", fontStyle: "italic" }}>to your stack</span>
            </h1>
            <p
              className="text-sm leading-relaxed max-w-xl"
              style={{ color: "rgba(245,240,232,0.45)", fontFamily: "'Montserrat', sans-serif" }}
            >
              Aurelius &amp; Co connects to Instagram via the official Graph API today. Integrations with Slack, Zapier, Google Sheets, and webhooks are on the roadmap — so your Instagram DM automation fits into the workflow you already have.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {INTEGRATIONS.map((integration, i) => (
              <motion.div
                key={integration.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="p-6"
                style={{
                  border: "1px solid rgba(201,168,76,0.15)",
                  background: integration.status === "Live" ? "rgba(201,168,76,0.03)" : "transparent",
                }}
              >
                <div className="flex items-start justify-between mb-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center"
                    style={{ border: "1px solid rgba(201,168,76,0.25)", color: "#C9A84C" }}
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                      <path d={integration.icon} />
                    </svg>
                  </div>
                  <span
                    className="text-xs tracking-widest uppercase"
                    style={{
                      color: integration.status === "Live" ? "#C9A84C" : "rgba(245,240,232,0.3)",
                      fontFamily: "'Montserrat', sans-serif",
                    }}
                  >
                    {integration.status}
                  </span>
                </div>
                <h3
                  className="text-lg font-light mb-2"
                  style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
                >
                  {integration.name}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "rgba(245,240,232,0.4)", fontFamily: "'Montserrat', sans-serif" }}
                >
                  {integration.desc}
                </p>
              </motion.div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p
              className="text-sm mb-4"
              style={{ color: "rgba(245,240,232,0.4)", fontFamily: "'Montserrat', sans-serif" }}
            >
              Need a custom integration?
            </p>
            <Link
              href="/contact"
              className="inline-block px-8 py-3 text-xs tracking-widest uppercase transition-all duration-300"
              style={{ border: "1px solid rgba(201,168,76,0.3)", color: "#C9A84C", fontFamily: "'Montserrat', sans-serif" }}
            >
              Request Integration
            </Link>
          </div>
        </motion.div>
      </main>
      <Footer />
    </>
  );
}
